var SplitPane = require('./lib/SplitPane');

module.exports = SplitPane;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-split-pane/index.js
// module id = 1573
// module chunks = 2